class CustomProductModal extends HTMLElement {
  constructor() {
    super();

    document.addEventListener('keyup', this.handleEscape.bind(this));
    this.modalOverlay = this.querySelector(".custom-product-gallery-overlay");
    this.modalOverlay.addEventListener("click",  this.closeModal.bind(this));

    this.slides = this.querySelectorAll(".custom-product-gallery-modal--slide");
    this.slidesArray = Array.from(this.slides);

    this.triggers = document.querySelectorAll('.product__media-toggle');
    this.triggerArray = Array.from(this.triggers);
    this.triggerArray.forEach(trigger => trigger.addEventListener('click', this.openModal.bind(this)));

    this.closeTrigger = this.querySelector(".custom-product-gallery-modal--close");
    this.closeTrigger.addEventListener("click",this.closeModal.bind(this));

    this.swiffysliderElement = this.querySelector(".swiffy-slider");
    this.sliderContainer = this.querySelector(".slider-container");
    swiffyslider.onSlideEnd(this.swiffysliderElement, this.getVisibleSlide.bind(this));
  }

  handleEscape(event){
    if(event.code.toUpperCase() === 'ESCAPE')this.closeModal()
  }

  openModal(event){
    document.body.classList.add('overflow-hidden');
    this.classList.add("open");
    this.slideToTarget(event);
  }

  closeModal(){
    this.classList.remove("open");
    document.body.classList.remove('overflow-hidden');
    document.removeEventListener('keyup', this.handleEscape.bind(this));
  }

  slideToTarget(event){
    this.slideIndex = event.target.dataset.index - 1;
    swiffyslider.slideTo(this.swiffysliderElement, this.slideIndex);
  }

  getVisibleSlide(){
    const gapWidth = parseInt(window.getComputedStyle(this.sliderContainer).columnGap);

    for (let i = 0; i < this.slidesArray.length; i++) {
        this.slide = this.slidesArray[i];
        this.slideScrollLeftPosition = Math.round(this.slide.getBoundingClientRect().left - this.sliderContainer.getBoundingClientRect().left) + 0.1;
        this.slideScrollRightPosition = Math.round(this.slideScrollLeftPosition + this.slide.offsetWidth - gapWidth) + 0.1;
        if (this.slideScrollLeftPosition >= 0 && this.slideScrollRightPosition <= this.sliderContainer.offsetWidth) {
            this.setActiveSlideNumber(this.slide);
        }
    }
  }

  setActiveSlideNumber(slide){
      this.activeSlideNumber = slide.querySelector(".slide-number").textContent;
      this.getSliderCounter = this.querySelector(".custom-product-gallery-modal--slide-number .active-slides");
      this.getSliderCounter.textContent = this.activeSlideNumber;
  }
  
};
  
  customElements.define('custom-product-modal', CustomProductModal);